export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#060D1A] pb-10 pt-20">
    <div className="grain-overlay" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col items-start justify-between gap-10 border-b border-white/10 pb-12 md:flex-row md:items-center">
        <div>
          <img src="/assets/prmg-logo.png" alt="PRMG - Paramount Residential Mortgage Group, Inc." className="h-9 w-auto" />
          <p className="mt-4 max-w-sm font-display text-lg font-bold text-[#FAF8F5]">
            Local Heroes. Stronger Communities. Brighter Futures.
          </p>
        </div>
        <div className="font-mono text-xs leading-loose text-[#FAF8F5]/60">
          <p className="font-bold uppercase tracking-[0.25em] text-[#F59E0B]">Aaron Rodriguez</p>
          <p>Loan Officer · NMLS #1559983</p>
          <p>
            <span className="font-body text-sm font-semibold tracking-wide">831-277-5422</span> · AaronR@prmg.net
          </p>
          <p>115 Westridge Industrial Blvd, Suite 301</p>
          <p>McDonough, GA 30253</p>
        </div>
      </div>

      <div className="border-b border-white/10 py-10 text-[11px] leading-relaxed text-[#FAF8F5]/45">
        <p data-testid="footer-disclaimer-credit">
          *The 1% lender credit is available on most FHA, VA and conventional loan programs but may not be used in conjunction
          with other loan programs, and is based on the loan
          amount. The credit is
          applied toward qualifying closing costs and cannot exceed the borrower's actual closing costs; no cash back is
          available. This is a lender-funded credit incentive offered at Paramount Residential Mortgage Group's discretion and is
          not a separate loan product or government program. Paramount Residential Mortgage Group, Inc. is not affiliated with,
          endorsed by, or acting on behalf of any government agency.
        </p>
      </div>

      <div className="flex flex-col items-start justify-between gap-6 pt-8 sm:flex-row sm:items-center">
        <div className="flex items-center gap-3">
          <img src="/assets/equal-housing.png" alt="Equal Housing Opportunity" className="h-8 w-auto opacity-70" />
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#FAF8F5]/50">Equal Housing Opportunity</span>
        </div>
        <nav data-testid="footer-legal-links" className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <a
            href="https://www.prmg.net/licenses/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-licensing-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#FAF8F5]/50 transition-colors hover:text-[#F59E0B]"
          >
            Licensing
          </a>
          <a
            href="https://www.prmg.net/terms-of-use/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-terms-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#FAF8F5]/50 transition-colors hover:text-[#F59E0B]"
          >
            Terms of Use
          </a>
          <a
            href="https://www.prmg.net/privacy-policy/"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-privacy-link"
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#FAF8F5]/50 transition-colors hover:text-[#F59E0B]"
          >
            Privacy Policy
          </a>
        </nav>
      </div>

      <p
        data-testid="footer-disclaimer-legal"
        className="mt-8 border-t border-white/10 pt-8 text-[11px] leading-relaxed text-[#FAF8F5]/45"
      >
        ©2026 Paramount Residential Mortgage Group, Inc. (“PRMG”) is a mortgage lender. NMLS ID# 75243
        (www.nmlsconsumeraccess.org). 1265 Corona Pointe Court, Suite 301, Corona, CA 92879. 866-776-4937. AZ Mortgage Banker
        License #BK-0910387. Licensed by the Department of Financial Protection and Innovation under the California Residential
        Mortgage Lending Act. Massachusetts Broker and Lender Licenses #MC75243. Licensed by the N.J. Department of Banking and
        Insurance. Rhode Island Licensed Lender and Loan Broker. Equal Housing Opportunity. Not a commitment to lend. All
        applications are subject to underwriting guidelines and product/program availability, creditworthiness, loan amount,
        property approval and other factors. Products and services may not be available in all areas and subject to change
        without notice.
      </p>
    </div>
  </footer>
);
